import { styled } from "@mui/material/styles";
import { Dialog, IconButton } from "@mui/material";

const DialogMain = styled(Dialog)(({ theme, jobPopup = false }) => ({
  "& .css-1t1j96h-MuiPaper-root-MuiDialog-paper": {
    maxWidth: "800px",
    width: jobPopup ? "650px" : "400px",
  },
  "& .MuiDialog-paper": {
    maxWidth: "800px",
    width: jobPopup ? "650px" : "400px",
  },
  "& .headerMain": {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },
  "& h6": {
    fontStyle: "normal",
    fontWeight: 500,
    fontSize: "18px",
    lineHeight: "22px",
    textTransform: "capitalize",
    color: "#0B0B0B",
    fontFamily: theme.typography.fontFamily,
  },

  "& label": {
    fontFamily: theme.typography.fontFamily,
    fontStyle: "normal",
    fontWeight: 600,
    fontSize: "16px",
    lineHeight: "22px",
    color: "#0B0B0B",
    marginBottom: "4px",
    display: "block",
  },

  "& .selected_jobsContent": {
    "& .TableWrapper": {
      marginTop: "0px",
      marginBottom: "0px",
    },
  },
}));
const IconButtonMain = styled(IconButton)(({ theme }) => ({
  border: "1px solid #E8E8E8",
  color: "#8E939B",
  "& svg": {
    fontSize: "15px",
  },
}));

export { DialogMain, IconButtonMain };
